import { IAmountable, ISelectedService, IState } from './state';
import { MutationTree } from 'vuex';

export default {
    setTravelerNumber(state, travelerNumber: number) {
        state.travelerNumber = travelerNumber;
    },
    setSingleRoomAmount(state, singleRoomAmount: number) {
        state.singleRoomAmount = singleRoomAmount;
    },
    setDoubleRoomAmount(state, doubleRoomAmount: number) {
        state.doubleRoomAmount = doubleRoomAmount;
    },
    setMixedRoomAmount(state, mixedRoomAmount: number) {
        state.mixedRoomAmount = mixedRoomAmount;
    },
    setSharedRoom(state, hasSharedDoubleRoom: boolean) {
        state.hasSharedDoubleRoom = hasSharedDoubleRoom;
    },
    setError(state, hasError: boolean) {
        state.hasError = hasError;
    },
    updateSelectedService(state, [amount, serviceUid]: IAmountable<number>) {
        const index = state.selectedServices.findIndex(([, service]) => service.uid === serviceUid);
        if (index > -1) {
            state.selectedServices[index][0] = amount;
            state.selectedServices = state.selectedServices.slice(0); // refresh object to trigger the getter
        }
    },
    setSalutation(state, salutation) {
        state.contactData.salutation = salutation;
    },
    setFirstName(state, firstname) {
        state.contactData.firstname = firstname;
    },
    setLastName(state, lastname) {
        state.contactData.lastname = lastname;
    },
    setStreetNr(state, streetNr) {
        state.contactData.streetnr = streetNr;
    },
    setZipCode(state, zipcode) {
        state.contactData.zipcode = zipcode;
    },
    setPlace(state, place) {
        state.contactData.place = place;
    },
    setCountry(state, country) {
        state.contactData.country = country.target.value;
    },
    setRawCountry(state, country) {
        state.contactData.country = country;
    },
    setPhone(state, phone) {
        state.contactData.phone = phone;
    },
    setEmail(state, email) {
        state.contactData.email = email;
    },
    setPersonalDataAdoption(state, adoptedToTravellerName) {
        state.personalDataAdoptedTo = adoptedToTravellerName;
    },
    setSharedDoubleRoomAmount(state, amount) {
        state.sharedDoubleRoomAmount = amount;
    },
    setCommonDoubleRoomAmount(state, amount) {
        state.commonDoubleRoomAmount = amount;
    },
    setDataAdoptionError(state) {
        state.hasDataAdoptionError = (state.contactData.firstname === '' && state.contactData.lastname === '' && state.contactData.salutation === '' && state.contactData.country === '');
    },
    setPrefix(state, prefix) {
        state.prefix = prefix;
    }
} as MutationTree<IState>
